import { FormControl } from '@angular/forms';
import { IBarreaux } from './barreaux.model';
import { IPays } from './referentials.model';

export interface ICarpaLight {
	id: string;
	nom?: string;
	tenantKey?: string;
	email?: string;
}

export interface ICarpa extends ICarpaLight {
	deviseReferenceId?: string;
	adresse1?: string;
	adresse2?: string;
	adresse3?: string;
	codePostal?: string;
	ville?: string;
	paysId?: string;
	telephone?: string;
	email?: string;
	fax?: string;
	domaineRacineEmail: string;
	adresseWeb?: string;
	siren?: string;
	mailDpdDpo?: string;
	nom?: string;
}

export interface ICarpaDetails extends ICarpa {
	adresseWeb?: string;
	siret?: string;
	siren?: string;
	mainMail?: string;
	nomCompletSigleCarpa?: string;
	referenceUnca?: string;
	othersMails?: string[];
	numeroTVAIntracommunautaire?: string;
	pays?: IPays;
	barreaux?: IBarreaux[];
	nic?: string;
	// Champs additifs pour l'édition BO (fullstack — optionnels pour ne pas régresser l'app-front)
	deviseReferenceId?: string;
	iban?: string;
	nomPresident?: string;
	emailPresident?: string;
	nomTresorier?: string;
	emailTresorier?: string;
	titreCabinet?: string;
	timeZone?: number;
	dateCreationCarpa?: string;
	dateClotureCarpa?: string;
	dateReprise?: string;
}

export interface IInformationsGeneralesForm {
	id?: FormControl<string | null>;
	nom: FormControl<string>;
	nomCompletSigleCarpa?: FormControl<string | null>;
	referenceUnca?: FormControl<string | null>;
	siren?: FormControl<string | null>;
	siret?: FormControl<string | null>;
	numeroTVAIntracommunautaire?: FormControl<string | null>;
	barreauxIds: FormControl<string | null>;
	adresse1: FormControl<string>;
	adresse2?: FormControl<string | null>;
	adresse3?: FormControl<string | null>;
	codePostal: FormControl<string>;
	ville: FormControl<string>;
	paysId: FormControl<string>;
	telephone: FormControl<string>;
	fax?: FormControl<string | null>;
	mainMail?: FormControl<string>;
	othersMails?: FormControl<string[] | null>;
	mailsList?: FormControl<string[] | null>;
	adresseWeb?: FormControl<string | null>;
	nic?: FormControl<string | null>;
}

export interface UpdateCarpaRequestDto {
	id: string;
	nom: string;
	adresse1: string;
	adresse2?: string;
	adresse3?: string;
	codePostal: string;
	siren?: string;
	numeroTVAIntracommunautaire?: string;
	fax?: string;
	adresseWeb: string;
	siret?: string;
	mainMail: string;
	ville: string;
	telephone: string;
	nomCompletSigleCarpa?: string;
	othersMails?: string[];
	barreauxIds: string;
	paysId: string;
	referenceUnca?: string;
	nic?: string;
	// Champs additifs pour l'édition BO (fullstack — optionnels pour ne pas régresser l'app-front)
	deviseReferenceId?: string;
	iban?: string;
	nomPresident?: string;
	emailPresident?: string;
	nomTresorier?: string;
	emailTresorier?: string;
	titreCabinet?: string;
	timeZone?: number;
	domaineRacineEmail?: string;
}

export interface IMailParam {
	mail: string;
	main: boolean;
}

export interface ILogoForm {
	logo?: FormControl<File | null>;
}

export enum TypeResources {
	SVG = 'image/svg+xml',
	JPEG = 'image/jpeg',
	PNG = 'image/png'
}
